module.exports = __webpack_public_path__ + "img/ai.3079be5f.svg";